import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AppService} from "@irb/app.service";
import {MoveSecuritiesGridDataDialogGridLayoutService} from "@irb/irb-editors/editor-security/move-securities-grid-data-dialog/move-securities-grid-data-dialog.grid-layout.service";

@Component({ standalone: false,
  selector: 'irb-move-securities-grid-data-dialog',
  templateUrl: './move-securities-grid-data-dialog.component.html',
  styleUrls: ['./move-securities-grid-data-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MoveSecuritiesGridDataDialogComponent implements OnInit {
  warningsData: {
    currentGroupSecurity: any,
    responseData: any[],
    hasCashSecurity: boolean,
    groupSecurities: any[],
    smaSecurities: any[],
    externalSecurities: any[],
    processArray: any[]
  };
  continueFunction: (warningsData: any) => {};
  grid: any;
  gridOptions: any;
  frameworkComponents: any;

  constructor(private as: AppService,
              public dialogRef: MatDialogRef<MoveSecuritiesGridDataDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public mdd: any,private gls: MoveSecuritiesGridDataDialogGridLayoutService) {

  }
  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No securities.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.warningsData = this.mdd.securitiesWarningsData;
    this.continueFunction = this.mdd.continueFunction;
  }
  close() {
    this.dialogRef.close();
  }

  onContinue() {
    this.continueFunction(this.warningsData);
    this.dialogRef.close();
  }
  
  onGridReady(params: any) {
    this.grid = params;
  }
}
